import React from 'react';
import './videbis-button.scss';
import { isEnter } from '../../util/functions';

interface Props {
    onPress: () => void;
    onDisabledPressed?: () => void;
    disabled?: boolean;
    text?: string;
    width?: number;
    txtColor?: string;
    bgColor?: string;
}


export const VidebisButton: React.FunctionComponent<Props> = props => {
    const disabled: boolean = props.disabled as boolean;
    const text: string = props.text ? props.text : 'Weiter';
    const width: number = props.width ? props.width : 15;

    const handleButtonPress = () => {
        if (disabled && props.onDisabledPressed) {
            props.onDisabledPressed();
        } else {
            props.onPress();
        }
    };

    return (
        <div className={'v-button' + (disabled ? ' disabled' : '')}
			 tabIndex={0}
             style={{
                 width: width + 'em',
                 color: props.txtColor,
                 backgroundColor: props.bgColor
             }}
             onKeyPress={evt => isEnter(evt) && handleButtonPress()}
             onClick={handleButtonPress}
        >
            <div className={'v-button__text'}>{text}</div>
        </div>
    );
};
